/* Mangy's — carrito drawer con AJAX Cart API de Shopify + cotizador LTL REAL */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  if (!document.getElementById('mgs-cart-deny-css')) {
    var _dc = document.createElement('style');
    _dc.id = 'mgs-cart-deny-css';
    _dc.textContent = '[data-line-box]{transition:box-shadow .15s ease}.cart-qty-deny{box-shadow:0 0 0 2px #ef4444 !important;animation:cart-qty-shake .4s ease}@keyframes cart-qty-shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}50%{transform:translateX(4px)}75%{transform:translateX(-3px)}}';
    document.head.appendChild(_dc);
  }
  var backdrop = document.querySelector('[data-cart-backdrop]');
  var list = drawer.querySelector('[data-cart-list]');
  var empty = drawer.querySelector('[data-cart-empty]');
  var shipping = drawer.querySelector('[data-cart-shipping]');
  var totalEl = drawer.querySelector('[data-cart-total]');
  var headerCount = drawer.querySelector('[data-cart-header-count]');
  var checkout = drawer.querySelector('[data-cart-checkout]');

  var LTL_ENDPOINT = 'https://ltl.mangystexports.com/api/ltl/estimate';
  var RATES = { MX:0.62, HN:0.74, GT:0.72, SV:0.74, NI:0.78, CR:0.80, PA:0.84, CO:0.92, VE:1.05, EC:0.98, DO:1.10, US:0.42 };
  var EN = (document.documentElement.lang || 'es').slice(0,2) === 'en';
  var PAIS = { MX:'México', HN:'Honduras', GT:'Guatemala', SV:'El Salvador', NI:'Nicaragua', CR:'Costa Rica', PA:'Panamá', CO:'Colombia', VE:'Venezuela', EC:'Ecuador', DO:'Rep. Dominicana', US:'Estados Unidos' };
  var PAIS_EN = { MX:'Mexico', HN:'Honduras', GT:'Guatemala', SV:'El Salvador', NI:'Nicaragua', CR:'Costa Rica', PA:'Panama', CO:'Colombia', VE:'Venezuela', EC:'Ecuador', DO:'Dominican Rep.', US:'United States' };
  function pais(c){ return (EN ? PAIS_EN : PAIS)[c] || c; }

  var lastCart = null, shipSelCents = 0, quoteForPacas = -1, carriers = [], selCarrier = null, destText = '';

  function money(cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function open() { drawer.classList.add('open'); backdrop.classList.add('open'); document.body.classList.add('cart-open'); drawer.setAttribute('aria-hidden', 'false'); }
  function close() { drawer.classList.remove('open'); backdrop.classList.remove('open'); document.body.classList.remove('cart-open'); drawer.setAttribute('aria-hidden', 'true'); }
  function setCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.style.display = n === 0 ? 'none' : ''; });
    if (headerCount) headerCount.textContent = n;
  }


  // ── Paga 2, lleva 4 ──
  // El descuento BXGY automático de Shopify solo regala las 2 gratis si el cliente las agrega él mismo.
  // Aquí el carrito las agrega solas: el grupo es de 4 (2 pagadas + 2 gratis), así que una paca de la
  // promo que quede en 2, 3, 6, 7… unidades sube hasta el siguiente múltiplo de 4. Si el cliente BAJA a
  // propósito con el botón −, respetamos esa cantidad (se guarda por variante en sessionStorage) hasta
  // que vuelva a subirla o a agregar esa paca.
  // Los IDs de producto de la colección `paga-2-lleva-4` vienen de snippets/mangys-cart-drawer.liquid.
  var P2L4 = window.MGS_P2L4 || [];
  var P2L4V = window.MGS_P2L4V || [];
  var p2Aviso = 0;
  function p2Es(it) { return !!it && P2L4.indexOf(it.product_id) !== -1; }
  function p2Skip() { try { return JSON.parse(sessionStorage.getItem('mgs_p2l4_skip') || '{}') || {}; } catch (e) { return {}; } }
  function p2SetSkip(vid, qty) {
    try {
      var sk = p2Skip();
      if (qty == null) { delete sk[String(vid)]; } else { sk[String(vid)] = qty; }
      sessionStorage.setItem('mgs_p2l4_skip', JSON.stringify(sk));
    } catch (e) {}
  }
  // Total por variante: al aplicar el descuento, Shopify parte la paca en 2 líneas (pagadas + las gratis).
  function p2Totales(cart) {
    var tot = {};
    (cart && cart.items || []).forEach(function (i) { if (p2Es(i)) tot[i.variant_id] = (tot[i.variant_id] || 0) + i.quantity; });
    return tot;
  }
  function p2Necesita(cart) {
    var sk = p2Skip(), tot = p2Totales(cart);
    return Object.keys(tot).some(function (v) { var r = tot[v] % 4; return (r === 2 || r === 3) && sk[String(v)] !== tot[v]; });
  }
  // En fila: si dos cosas piden completar a la vez (p. ej. al cargar /cart), la segunda espera a la
  // primera y vuelve a leer el carrito, así nunca se agregan 2 gratis por error.
  var p2Cola = Promise.resolve(), p2Pend = 0;
  function p2Completar(cart) {
    if (!P2L4.length || !cart || !cart.items) return Promise.resolve(cart);
    if (!p2Pend && !p2Necesita(cart)) return Promise.resolve(cart);
    p2Pend++;
    var run = p2Cola
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(p2Paso)
      .then(function (c) { p2Pend--; return c; }, function () { p2Pend--; return cart; });
    p2Cola = run;
    return run;
  }
  function p2Paso(cart) {
    var sk = p2Skip(), tot = p2Totales(cart), vid = null;
    Object.keys(tot).some(function (v) { var r = tot[v] % 4; if ((r === 2 || r === 3) && sk[String(v)] !== tot[v]) { vid = v; return true; } return false; });
    if (!vid) return cart;
    var antes = tot[vid];
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(vid), quantity: 1 }) })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (nuevo) {
        var ahora = p2Totales(nuevo)[vid] || 0;
        // sin inventario para la gratis (u otro error): no insistimos con esta paca en esta cantidad
        if (ahora <= antes) { p2SetSkip(vid, ahora); return nuevo; }
        p2Aviso += 1;
        return p2Paso(nuevo);
      });
  }
  // Por variante de la promo: T = total en el carrito, F = gratis (según el descuento real), P = pagadas.
  function p2Grupos(cart) {
    var g = {};
    (cart && cart.items || []).forEach(function (i) {
      if (!p2Es(i)) return;
      var x = g[i.variant_id] || (g[i.variant_id] = { T: 0, desc: 0, unit: i.original_price, keys: [] });
      x.T += i.quantity; x.desc += (i.original_line_price - i.final_line_price); x.keys.push(i.key);
    });
    Object.keys(g).forEach(function (v) { var x = g[v]; x.F = x.unit ? Math.round(x.desc / x.unit) : 0; x.P = x.T - x.F; });
    return g;
  }
  // Fija cuántas PAGADAS quiere el cliente de una paca de la promo y deja el total = pagadas + 2 gratis por cada 2.
  function p2SetPaid(vid, pag) {
    pag = Math.max(0, pag || 0);
    var meta = pag + 2 * Math.floor(pag / 2);
    p2SetSkip(vid, null);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {}, n = 0;
        cart.items.forEach(function (l) { if (String(l.variant_id) === String(vid)) { updates[l.key] = n === 0 ? meta : 0; n++; } });
        if (!n) return cart;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
          .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
          .then(function (nuevo) {
            var t = p2Totales(nuevo)[vid] || 0;
            if (t < meta) nuevo.__p2deny = String(vid);   // no alcanzó el inventario
            return p2Completar(nuevo).then(function (c) { if (nuevo.__p2deny) c.__p2deny = nuevo.__p2deny; return c; });
          });
      });
  }
  function p2Toast(n) {
    var t = drawer.querySelector('[data-p2-toast]');
    if (!t) {
      t = document.createElement('div');
      t.setAttribute('data-p2-toast', '');
      t.setAttribute('role', 'status');
      t.style.cssText = 'background:#143601;color:#fde68a;border-radius:14px;padding:10px 14px;margin:0 0 10px;font-size:13px;font-weight:700;text-align:center;line-height:1.3';
      list.parentNode.insertBefore(t, list);
    }
    t.textContent = n > 1 ? (EN ? ('Done! We added ' + n + ' free bales.') : ('¡Listo! Te agregamos ' + n + ' pacas gratis.'))
                      : (EN ? 'Done! We added 1 free bale.' : '¡Listo! Te agregamos 1 paca gratis.');
    t.style.display = '';
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.style.display = 'none'; }, 6000);
  }
  function p2Chip(it, tot, primera) {
    var base = 'display:inline-block;margin-top:4px;border-radius:999px;padding:2px 8px;font-size:10.5px;font-weight:800;line-height:1.35;';
    var ahorro = it.original_line_price - it.final_line_price;
    if (p2Es(it)) {
      if (ahorro > 0 && it.original_price > 0) {
        var n = Math.round(ahorro / it.original_price);
        var txt = n >= it.quantity ? (EN ? 'Free' : 'Gratis') : (EN ? (n + ' free') : (n + ' gratis'));
        return '<span style="' + base + 'background:#fde68a;color:#143601">' + txt + (EN ? ' · Buy 2, get 4' : ' · Paga 2, lleva 4') + '</span>';
      }
      if (!primera) return '';
      if (tot % 4 === 1) return '<span style="' + base + 'background:#eef5e2;color:#245501">' + (EN ? 'Add 1 more and get 2 free' : 'Agrega 1 más y te llevas 2 gratis') + '</span>';
      if (tot % 4 === 2) return '<span style="' + base + 'background:#eef5e2;color:#245501">' + (EN ? 'Add 2 more: they’re free' : 'Agrega 2 más: te salen gratis') + '</span>';
      if (tot % 4 === 3) return '<span style="' + base + 'background:#eef5e2;color:#245501">' + (EN ? 'Add 1 more: it’s free' : 'Agrega 1 más: te sale gratis') + '</span>';
      return '';
    }
    // $50 menos en el envío (desde 5 oct 2026): descuento automático 50MENOSENVIO → chip con su nombre
    var e50 = (it.line_level_discount_allocations || []).some(function (d) { return d.discount_application && /MENOSENVIO/i.test(d.discount_application.title || ''); });
    if (ahorro > 0 && e50) return '<span style="' + base + 'background:#ffedd5;color:#9a3412">' + (EN ? 'Shipping −' : 'Envío −') + money(ahorro) + ' · 50MENOSENVIO</span>';
    if (ahorro > 0) return '<span style="' + base + 'background:#eef5e2;color:#245501">' + (EN ? 'You save ' : 'Ahorras ') + money(ahorro) + '</span>';
    return '';
  }

  // refs del cotizador
  var qForm = shipping.querySelector('[data-quote-form]');
  var qResult = shipping.querySelector('[data-quote-result]');
  var qDest = shipping.querySelector('[data-quote-dest]');
  var qLoading = shipping.querySelector('[data-quote-loading]');
  var qPick = shipping.querySelector('[data-quote-pick]');
  var carriersEl = shipping.querySelector('[data-cart-carriers]');
  var normalRow = shipping.querySelector('[data-ship-normal-row]');
  var normalEl = shipping.querySelector('[data-ship-normal]');
  var promoEl = shipping.querySelector('[data-ltl-promo]');
  var missEl = shipping.querySelector('[data-ltl-missing]');
  var qErr = shipping.querySelector('[data-quote-err]');
  var ccModal = document.querySelector('[data-cart-carrier-modal]');
  var ccList = ccModal ? ccModal.querySelector('[data-cc-list]') : null;
  var selSummary = shipping.querySelector('[data-cart-carrier-sel]');
  var selName = shipping.querySelector('[data-cc-sel-name]');
  var selPrice = shipping.querySelector('[data-cc-sel-price]');
  if (ccModal) ccModal.querySelectorAll('[data-cc-close]').forEach(function (b) { b.addEventListener('click', function () { ccModal.classList.remove('open'); }); });

  function resetQuote() {
    shipSelCents = 0; quoteForPacas = -1; carriers = []; selCarrier = null;
    if (qForm) qForm.classList.remove('hidden');
    if (qResult) qResult.classList.add('hidden');
    if (selSummary) { selSummary.classList.add('hidden'); selSummary.classList.remove('flex'); }
    if (ccModal) ccModal.classList.remove('open');
  }
  function updateTotal() { if (lastCart) totalEl.textContent = money(lastCart.total_price + shipSelCents); }

  // Cuenta pacas por PESO, no por cantidad de líneas: cada paca ~100 lb.
  // Un producto "combo" (1 línea, ej. libraje 600 lb) cuenta como 6 pacas, no 1.
  function pacaCount(cart) {
    if (!cart || !cart.items) return 0;
    var n = 0;
    cart.items.forEach(function (it) {
      var lbs = (it.grams || 0) / 453.592;
      n += Math.max(1, Math.round(lbs / 100)) * (it.quantity || 1);
    });
    return n;
  }

  function render(cart) {
    lastCart = cart;
    var qty = cart.item_count;
    setCounts(qty);
    if (qty === 0) {
      empty.style.display = ''; list.innerHTML = ''; shipping.classList.add('hidden');
      checkout.disabled = true; resetQuote(); totalEl.textContent = money(0); return;
    }
    empty.style.display = 'none'; shipping.classList.remove('hidden'); checkout.disabled = false;

    var TRASH = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>';
    var BTN = 'class="w-6 h-6 rounded-full bg-white text-mangys-900 flex items-center justify-center font-bold"';
    function fila(it, o) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" class="w-full h-full object-cover">' : '';
      return '<li class="flex items-center gap-3 rounded-2xl border ' + (o.gratis ? '' : 'border-mangys-100 bg-white ') + 'p-3"' + (o.gratis ? ' style="border-color:#fde68a;background:#fffbeb"' : '') + '>' +
        '<div class="w-14 h-14 rounded-xl bg-mangys-50 overflow-hidden flex items-center justify-center flex-shrink-0">' + img + '</div>' +
        '<div class="flex-1 min-w-0"><div class="text-sm font-semibold text-mangys-900 truncate">' + it.product_title + '</div>' +
        '<div class="text-xs text-mangys-800/55">' + money(it.original_price) + (EN ? ' ea.' : ' c/u') + '</div>' + (o.chip || '') + o.qty + '</div>' +
        '<div class="flex flex-col items-end gap-1">' + (o.tachado ? '<s class="text-[11px] text-mangys-800/40">' + money(o.tachado) + '</s>' : '') +
        '<div class="font-display font-bold text-mangys-900 text-sm">' + money(o.total) + '</div>' + (o.del || '') + '</div></li>';
    }
    var chipBase = 'display:inline-block;margin-top:4px;border-radius:999px;padding:2px 8px;font-size:10.5px;font-weight:800;line-height:1.35;';
    var grupos = p2Grupos(cart), hechos = {};
    list.innerHTML = cart.items.map(function (it) {
      if (!p2Es(it)) {
        return fila(it, {
          chip: p2Chip(it, it.quantity, true),
          qty: '<div data-line-box="' + it.key + '" class="mt-1.5 inline-flex items-center gap-1 rounded-full bg-mangys-50 px-1.5 py-0.5">' +
            '<button type="button" data-line="' + it.key + '" data-qty="' + (it.quantity - 1) + '" ' + BTN + '>−</button>' +
            '<span class="text-xs font-bold px-2 text-mangys-900">' + it.quantity + '</span>' +
            '<button type="button" data-line="' + it.key + '" data-qty="' + (it.quantity + 1) + '" ' + BTN + '>+</button></div>',
          tachado: it.final_line_price < it.original_line_price ? it.original_line_price : 0,
          total: it.final_line_price,
          del: '<button type="button" data-line="' + it.key + '" data-qty="0" aria-label="' + (EN ? 'Remove' : 'Quitar') + '" class="text-mangys-400 hover:text-red-600">' + TRASH + '</button>'
        });
      }
      // Paca de la promo: UNA fila con las pagadas (con −/+/quitar) y UNA fila con las gratis (sin botones)
      if (hechos[it.variant_id]) return '';
      hechos[it.variant_id] = true;
      var g = grupos[it.variant_id], vid = it.variant_id, html = '';
      if (g.P > 0) {
        var pista = '';
        if (g.P % 2 === 1) pista = '<span style="' + chipBase + 'background:#eef5e2;color:#245501">' + (EN ? 'Add 1 more and get 2 free' : 'Agrega 1 más y te regalamos 2') + '</span>';
        html += fila(it, {
          chip: pista,
          qty: '<div data-line-box="p2-' + vid + '" class="mt-1.5 inline-flex items-center gap-1 rounded-full bg-mangys-50 px-1.5 py-0.5">' +
            '<button type="button" data-p2v="' + vid + '" data-p2p="' + (g.P - 1) + '" ' + BTN + '>−</button>' +
            '<span class="text-xs font-bold px-2 text-mangys-900">' + g.P + '</span>' +
            '<button type="button" data-p2v="' + vid + '" data-p2p="' + (g.P + 1) + '" ' + BTN + '>+</button></div>',
          total: g.P * g.unit,
          del: '<button type="button" data-p2v="' + vid + '" data-p2p="0" aria-label="' + (EN ? 'Remove' : 'Quitar') + '" class="text-mangys-400 hover:text-red-600">' + TRASH + '</button>'
        });
      }
      if (g.F > 0) {
        html += fila(it, {
          gratis: true,
          chip: '<span style="' + chipBase + 'background:#fde68a;color:#143601">' + (g.F > 1 ? (g.F + (EN ? ' free' : ' gratis')) : (EN ? 'Free' : 'Gratis')) + (EN ? ' · Buy 2, get 4' : ' · Paga 2, lleva 4') + '</span>',
          qty: '<div class="mt-1.5 text-xs font-bold text-mangys-900">× ' + g.F + '</div>',
          tachado: g.F * g.unit,
          total: 0
        });
      }
      return html;
    }).join('');
    list.querySelectorAll('[data-line]').forEach(function (b) {
      b.addEventListener('click', function () { changeLine(b.getAttribute('data-line'), parseInt(b.getAttribute('data-qty'), 10)); });
    });
    list.querySelectorAll('[data-p2v]').forEach(function (b) {
      b.addEventListener('click', function () {
        list.querySelectorAll('[data-p2v]').forEach(function (x) { x.disabled = true; });
        var vid = b.getAttribute('data-p2v');
        p2SetPaid(vid, parseInt(b.getAttribute('data-p2p'), 10))
          .then(function (c) { render(c); if (c && c.__p2deny) flashDeny('p2-' + c.__p2deny); })
          .catch(function () { refresh(false); });
      });
    });

    if (p2Aviso) { p2Toast(p2Aviso); p2Aviso = 0; }

    // Si la cantidad cambió respecto a la cotización vigente, invalidar (hay que re-cotizar)
    if (quoteForPacas !== -1 && quoteForPacas !== pacaCount(cart)) resetQuote();
    updateTotal();
  }

  function refresh(openAfter) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return p2Completar(cart); })
      .then(function (cart) { render(cart); if (openAfter) open(); });
  }
  function flashDeny(key) {
    var box = list.querySelector('[data-line-box="' + key + '"]');
    if (box) { box.classList.add('cart-qty-deny'); setTimeout(function () { box.classList.remove('cart-qty-deny'); }, 1000); }
    if (navigator.vibrate) { try { navigator.vibrate([55, 40, 55]); } catch (e) {} }
  }
  function changeLine(key, qty) {
    var prev = lastCart && lastCart.items ? lastCart.items.filter(function (i) { return i.key === key; })[0] : null;
    if (p2Es(prev)) {
      var totAntes = p2Totales(lastCart)[prev.variant_id] || prev.quantity;
      var totDespues = totAntes - prev.quantity + qty;
      // bajó o quitó una línea a propósito: respetar esa cantidad; subió: se vuelve a completar
      if (qty < prev.quantity && totDespues > 0) p2SetSkip(prev.variant_id, totDespues);
      else if (qty > prev.quantity) p2SetSkip(prev.variant_id, null);
    }
    // /cart/change.js: si pedís más de lo que hay en inventario, Shopify clampea (200 con
    // cantidad menor) o rechaza (422). En ambos casos avisamos con el bloqueo rojo + vibración.
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        var cart = res.d;
        if (res.ok && cart && cart.items) {
          var line = cart.items.filter(function (i) { return i.key === key; })[0];
          if (qty > 0 && (!line || line.quantity < qty)) { render(cart); flashDeny(key); }
          else { p2Completar(cart).then(render); }
        } else {
          // Error (p. ej. 422 por inventario): recuperamos el carrito real y avisamos.
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (real) {
              render(real);
              var rl = (real.items || []).filter(function (i) { return i.key === key; })[0];
              if (qty > 0 && rl && rl.quantity < qty) flashDeny(key);
            });
        }
      })
      .catch(function () { refresh(false); });
  }
  function addPost(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
  }
  function addVariant(id, qty) {
    qty = qty || 1;
    p2SetSkip(id, null);
    // Paga 2, lleva 4 — regla "por cada 2, te regalamos 2" (si llevas 4 pagadas, te regalamos 4): lo que el
    // cliente pide son las PAGADAS; sumamos las gratis de una vez (con 8 en el carrito el BXGY regala 4).
    // Si no alcanza el inventario para las gratis, se agrega solo lo pedido y después se completa lo que se pueda.
    var esP2 = P2L4V.indexOf(Number(id)) !== -1;
    var pre = esP2 ? fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; }) : Promise.resolve(null);
    return pre
      .then(function (cart) {
        if (!cart) return addPost(id, qty);
        var tot0 = p2Totales(cart)[String(id)] || 0;
        var pag1 = (tot0 - 2 * Math.floor(tot0 / 4)) + qty;
        var n = Math.max(qty, pag1 + 2 * Math.floor(pag1 / 2) - tot0);
        if (n === qty) return addPost(id, qty);
        return addPost(id, n).then(function (r) {
          if (r.ok) { p2Aviso += n - qty; return r; }
          return addPost(id, qty);
        });
      })
      .then(function (r) { return r.d; })
      .then(function (res) {
        if (!P2L4.length) return res;
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(p2Completar)
          .then(function () { return res; }, function () { return res; });
      });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); refresh(true); }); });
  drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
  if (backdrop) backdrop.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-add-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var q = form.querySelector('[name="quantity"]');
    addVariant(id, q ? parseInt(q.value, 10) : 1).then(function () { refresh(true); });
  });
  window.addEventListener('cart:add', function (ev) {
    var d = ev.detail || {};
    if (!d.id) return;
    addVariant(d.id, d.quantity || 1).then(function () { refresh(true); });
  });
  window.MangysCart = { add: addVariant, refresh: refresh, open: function () { refresh(true); }, p2l4: p2Completar, p2skip: p2SetSkip, p2paid: p2SetPaid };
  // Página /cart (se pinta en el servidor): si una paca de la promo quedó en 2, 5, 8… (p. ej. por un
  // formulario normal), la completamos y recargamos para que se vea con el descuento.
  if (document.querySelector('[data-cart-page]') && P2L4.length) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { return p2Completar(c).then(function (n) { if (n && n.item_count !== c.item_count) window.location.reload(); }); });
  }

  // ── Cotizador ──
  function normalQuote(country, qty) {
    // Sin tarifa real de Shopify para este destino: NO inventamos un estimado
    // (confundía al cliente vs. el precio real del checkout). Avisamos que se calcula allá.
    shipSelCents = 0;
    if (normalRow) {
      var lbl = normalRow.querySelector('span');
      if (lbl) lbl.textContent = (EN ? 'Calculated at checkout' : 'Se calcula en el checkout');
      if (normalEl) normalEl.textContent = '—';
      normalRow.classList.remove('hidden');
    }
    updateTotal();
  }
  // Tarifas reales de Shopify (las de tu config de envíos). Respaldo: normalQuote.
  function realQuote(country, state, zip, qty) {
    qLoading.classList.remove('hidden');
    var cname = PAIS_EN[country] || country;
    var params = 'shipping_address[country]=' + encodeURIComponent(cname) + '&shipping_address[province]=' + encodeURIComponent(state) + '&shipping_address[zip]=' + encodeURIComponent(zip);
    fetch('/cart/prepare_shipping_rates.json?' + params, { method: 'POST' })
      .then(function () { pollRates(0, country, qty); })
      .catch(function () { qLoading.classList.add('hidden'); normalQuote(country, qty); });
  }
  function pollRates(attempt, country, qty) {
    fetch('/cart/async_shipping_rates.json').then(function (r) { return r.text(); }).then(function (txt) {
      var data = null; try { data = JSON.parse(txt); } catch (e) {}
      if (!data && attempt < 16) { setTimeout(function () { pollRates(attempt + 1, country, qty); }, 700); return; }
      qLoading.classList.add('hidden');
      var rates = (data && data.shipping_rates) || [];
      if (!rates.length) { normalQuote(country, qty); return; }
      carriers = rates.map(function (rt) {
        return { carrier: rt.name, priceUsd: parseFloat(rt.price) || 0, serviceDays: null };
      }).sort(function (a, b) { return a.priceUsd - b.priceUsd; });
      renderCarriers();
      if (carriers.length === 1) selectCarrier(0);
    }).catch(function () { qLoading.classList.add('hidden'); normalQuote(country, qty); });
  }
  function carrierRow(q, i) {
    var meta = q.serviceDays ? (((Number(q.serviceDays)||0)+1) + (EN ? ' business days' : ' días hábiles')) : (EN ? 'Transit time to be confirmed' : 'Tránsito por confirmar');
    return '<button type="button" data-carrier="' + i + '" class="cart-carrier w-full flex items-center gap-2 rounded-lg border border-mangys-100 bg-white px-2.5 py-2 text-left">' +
      '<span class="cart-carrier-radio"></span>' +
      '<span class="flex-1 min-w-0"><span class="block text-[0.72rem] font-bold text-mangys-900 truncate">' + esc(q.carrier || (EN ? 'LTL carrier' : 'Transportista LTL')) + '</span><span class="block text-[0.6rem] text-mangys-800/55">' + meta + '</span></span>' +
      '<span class="text-[0.74rem] font-bold text-mangys-700 whitespace-nowrap">$' + (Number(q.priceUsd || 0)).toLocaleString('en-US', { minimumFractionDigits: 2 }) + '</span></button>';
  }
  function bindCarrierClicks(container) {
    if (!container) return;
    container.querySelectorAll('[data-carrier]').forEach(function (el) {
      el.addEventListener('click', function () { selectCarrier(parseInt(el.getAttribute('data-carrier'), 10)); });
    });
  }
  function selectCarrier(i) {
    selCarrier = carriers[i];
    shipSelCents = Math.round(Number(carriers[i].priceUsd || 0) * 100);
    [carriersEl, ccList].forEach(function (cont) {
      if (!cont) return;
      cont.querySelectorAll('.cart-carrier').forEach(function (c) { c.classList.toggle('sel', c.getAttribute('data-carrier') === String(i)); });
    });
    if (selSummary) {
      selName.textContent = selCarrier.carrier || (EN ? 'LTL carrier' : 'Transportista LTL');
      selPrice.textContent = '$' + (Number(selCarrier.priceUsd || 0)).toLocaleString('en-US', { minimumFractionDigits: 2 });
      selSummary.classList.remove('hidden'); selSummary.classList.add('flex');
    }
    if (ccModal) ccModal.classList.remove('open');
    updateTotal();
  }
  function renderCarriers() {
    qPick.classList.remove('hidden');
    carriersEl.classList.remove('hidden');
    var html = carriers.slice(0, 4).map(function (q, i) { return carrierRow(q, i); }).join('');
    if (carriers.length > 4) {
      html += '<button type="button" data-cc-open class="w-full rounded-lg border border-dashed border-mangys-300 bg-white px-2.5 py-2 text-[0.72rem] font-bold text-mangys-700 hover:bg-mangys-50 transition-colors">+ ' + (carriers.length - 4) + (EN ? ' more carriers' : ' transportistas más') + '</button>';
    }
    carriersEl.innerHTML = html;
    bindCarrierClicks(carriersEl);
    if (ccList) { ccList.innerHTML = carriers.map(function (q, i) { return carrierRow(q, i); }).join(''); bindCarrierClicks(ccList); }
    var openBtn = carriersEl.querySelector('[data-cc-open]');
    if (openBtn) openBtn.addEventListener('click', function () { if (ccModal) ccModal.classList.add('open'); });
  }

  var go = drawer.querySelector('[data-quote-go]');
  if (go) go.addEventListener('click', function () {
    var stuChk = drawer.querySelector('[data-storage-check]');
    if (stuChk && stuChk.checked) { if (window.MangysStoragePopup) window.MangysStoragePopup.open(); return; }
    var c = drawer.querySelector('[data-quote-country]').value;
    var s = drawer.querySelector('[data-quote-state]').value.trim();
    var z = drawer.querySelector('[data-quote-zip]').value.trim();
    var err = drawer.querySelector('[data-quote-error]');
    if (!c || !s || !z) { if (err) err.classList.remove('hidden'); return; }
    if (err) err.classList.add('hidden');
    if (!lastCart) return;
    var qty = pacaCount(lastCart);
    quoteForPacas = qty; shipSelCents = 0; selCarrier = null; carriers = [];
    destText = (EN ? 'Shipping to ' : 'Envío a ') + pais(c) + ' · ' + s + ' · ' + z;
    qForm.classList.add('hidden'); qResult.classList.remove('hidden');
    qDest.textContent = destText;
    qPick.classList.add('hidden'); carriersEl.classList.add('hidden'); carriersEl.innerHTML = '';
    normalRow.classList.add('hidden'); promoEl.classList.add('hidden'); qErr.classList.add('hidden'); qLoading.classList.add('hidden');

    if (c !== 'US') { realQuote(c, s, z, qty); return; }
    if (qty < 5) { missEl.textContent = (5 - qty); promoEl.classList.remove('hidden'); realQuote('US', s, z, qty); return; }

    qLoading.classList.remove('hidden');
    fetch(LTL_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ pacaCount: qty, destination: { zip: z, country: 'US', state: s.toUpperCase() } }) })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (data) {
        qLoading.classList.add('hidden');
        if (!data.qualifies || !data.quotes || !data.quotes.length) {
          if (data.reason === 'below_minimum') { var m = (data.minRequired || 5) - qty; missEl.textContent = m > 0 ? m : 1; promoEl.classList.remove('hidden'); normalQuote('US', qty); }
          else { realQuote('US', s, z, qty); } // GTZ caido -> respaldo: tarifas reales de Shopify
          return;
        }
        carriers = data.quotes; renderCarriers();
      })
      .catch(function () { qLoading.classList.add('hidden'); realQuote('US', s, z, qty); }); // sin respuesta del LTL -> respaldo Shopify
  });

  var edit = drawer.querySelector('[data-quote-edit]');
  if (edit) edit.addEventListener('click', function () { resetQuote(); });

  if (checkout) checkout.addEventListener('click', function () {
    if (selCarrier) {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { ltl_quote_id: String(selCarrier.quoteId || ''), ltl_carrier: String(selCarrier.carrier || ''), ltl_price_usd: String(selCarrier.priceUsd || ''), ltl_destino: destText } }) })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/checkout'; });
    } else { window.location.href = '/checkout'; }
  });

  refresh(false);
})();
